import * as _ from 'lodash';

export function searchCollection(objects: any[], fields: string[], originalTerm: string) {
  if (!originalTerm) {
    return objects;
  }

  const term = originalTerm.toLowerCase().replace(/[^a-z0-9]/g, '');
  if (!term) {
    return objects;
  }

  return objects.filter(o => {
    const data = _.chain(o)
      .pick(fields)  // get an object with the fields we want to search
      .values()      // get those values in the array (don't need the keys anymore)
      .compact()     // get rid of empty values
      .map((v) => v.toString().toLowerCase().replace(/[^a-z0-9,]/g, '')) // normalize to lowercase and only letters and numbers
      .join(',')     // create a comma delimited string we will search
      .value();

    return data.includes(term);
  })
}
